import React from 'react';

const ForeFlightLogo = () => {
    return (
        <svg
            className="logo"
            width="50"
            height="50"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.8797 17.9994C26.8797 13.0957 22.9042 9.12022 18 9.12022C13.0958 9.12022 9.11952 13.0957 9.11952 17.9994C9.11952 22.904 13.0958 26.8795 18 26.8795C22.9042 26.8795 26.8797 22.904 26.8797 17.9994ZM33.5889 26.9993L24.3637 24.3627L27.0005 33.5872L20.329 26.6925L18 36L15.671 26.6925L9.00051 33.5872L11.6353 24.3627L2.41233 26.9993L9.30683 20.3278L0 17.9994L9.30683 15.6696L2.41233 8.99866L11.6353 11.6357L9.00051 2.41104L15.671 9.306L18 0L20.329 9.306L27.0005 2.41104L24.3637 11.6357L33.5889 8.99866L26.6939 15.6696L36 17.9994L26.6939 20.3278L33.5889 26.9993ZM19.1605 18.875L18.9987 21.8862L20.9371 23.5067L20.6784 24.1854L18.8708 23.667L18.6114 24.8332C18.6114 24.8332 18.2956 24.891 17.9883 24.905C17.7607 24.9137 17.3876 24.8332 17.3876 24.8332L17.1292 23.667L15.3193 24.1854L15.0632 23.5067L17.0008 21.8862L16.84 18.875L11.2197 19.6194L10.7342 18.6793L16.8068 16.0883C16.8068 16.0883 16.817 14.1503 16.8545 13.4303C16.8853 12.8317 17.0321 11.1031 18.0013 11.1021C18.9651 11.1031 19.1055 12.8462 19.1368 13.4469C19.1751 14.1658 19.1944 16.0883 19.1944 16.0883L25.2658 18.6793L24.7801 19.6194L19.1605 18.875Z"
                fill="white"
            />
        </svg>
    );
};
export default ForeFlightLogo;
